import { TextHIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Heading = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextHIcon {...rest} size={Sizes[size]} color={fill} />;
};

Heading.displayName = 'Heading';
